import React from "react"

import { link } from "./Footer.module.css"

const Footer = ({ email, phone, address }) => {
  const whatsappNumber = phone.replace(/\D/g, "")
  const contactInfo = [
    {
      text: phone,
      type: "tel",
    },
    {
      text: email,
      type: "email",
    },
  ]
  return (
    <footer className="bg-secondary p-8 text-gray-50 footer">
      <div className="container">
        <div className="flex flex-col md:flex-row justify-around mb-6">
          <div>
            <div className="text-lg mb-3 text-center">Contacto</div>
            <ul className="flex flex-col items-center">
              {contactInfo.map(contact => (
                <li key={contact.text} className="text-sm pb-2">
                  {contact.type === "email" ? (
                    <a className={link} href={`mailto:${contact.text}`}>
                      <span className="icon-envelope mr-1" aria-hidden="true" />
                      {contact.text}
                    </a>
                  ) : (
                    <a className={link} href={`tel:${contact.text}`}>
                      <span
                        className="icon-phone-square mr-1"
                        aria-hidden="true"
                      />
                      {contact.text}
                    </a>
                  )}
                </li>
              ))}
              <li className="text-sm pb-2">
                <a
                  className={link}
                  href={`https://wa.me/${whatsappNumber}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Contactar por WhatsApp"
                >
                  <svg
                    className="inline-block mr-1 align-text-bottom"
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                  </svg>
                  WhatsApp
                </a>
              </li>
            </ul>
          </div>
          <div>
            <div className="text-lg mb-3 text-center">Dirección</div>
            <ul className="flex flex-col items-center">
              <li className="text-sm">
                <address className="not-italic">
                  <span className="icon-home mr-1" aria-hidden="true" />
                  <a
                    className={link}
                    href="https://maps.google.com/?q=Jujuy+71,+PB+Local+03,+C%C3%B3rdoba,+Argentina"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Ver ubicación en Google Maps"
                  >
                    {address}
                  </a>
                </address>
              </li>
            </ul>
          </div>
          <div>
            <div className="text-lg mb-3 text-center">Horario de atención</div>
            <ul className="flex flex-col items-center text-sm gap-1">
              <li>Lunes a Viernes</li>
              <li>09:00 – 13:00</li>
              <li>14:00 – 17:30</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-green-600 pt-4 text-center text-sm">
          Griguol © {new Date().getFullYear()}
        </div>
      </div>
    </footer>
  )
}

export default Footer
